import * as React from 'react';

import { CharacterTheme, Item, ItemUtils } from '@dndbeyond/character-rules-engine/es';

import { BaseInventoryName } from './BaseInventoryName';

interface Props {
    item: Item;
    onClick?: (item: Item) => void;
    showIcons: boolean;
    className: string;
    theme: CharacterTheme;
}
export default class ItemName extends React.PureComponent<Props> {
    static defaultProps = {
        showIcons: true,
        className: '',
    };

    handleClick = (): void => {
        const { onClick, item } = this.props;

        if (onClick) {
            onClick(item);
        }
    };

    render() {
        const { item, showIcons, className, onClick, theme } = this.props;

        return (
            <BaseInventoryName
                item={item}
                nameOverride={ItemUtils.getName(item)}
                className={className}
                onClick={onClick ? this.handleClick : undefined}
                isCustomized={ItemUtils.isCustomized(item)}
                showIcons={showIcons}
                theme={theme}
            />
        );
    }
}
